__turbopack_context__.v({
  "gradient": "ClubProfileHero-module-scss-module__jkAOJq__gradient",
  "hero": "ClubProfileHero-module-scss-module__jkAOJq__hero",
  "image": "ClubProfileHero-module-scss-module__jkAOJq__image",
  "imageWrapper": "ClubProfileHero-module-scss-module__jkAOJq__imageWrapper",
  "shimmer": "ClubProfileHero-module-scss-module__jkAOJq__shimmer",
  "skeleton": "ClubProfileHero-module-scss-module__jkAOJq__skeleton",
});
